<script lang="ts" setup>
import { Popup, Radio } from "vant";
import { useTranslate } from "@/stores/translate";
import { isMobile } from "@/modules/common";
import { TranslationLanguageEnum } from "@/enums/translateEnums";
import { ref, watch } from "vue";

const translateStore = useTranslate();
const langList = Object.values(TranslationLanguageEnum).map((item) => ({
  label: `translate['lang']['${item}']`,
  value: item,
}));
const tmpVal = ref(translateStore.targetLang);
watch(
  () => translateStore.showLangSelection,
  (val) => {
    if (!val) {
      tmpVal.value = translateStore.targetLang;
    }
  }
);
</script>
<template>
  <Popup
    v-model:show="translateStore.showLangSelection"
    :position="isMobile() ? 'bottom' : 'center'"
    class="max-h-[80%] w-full lg:max-w-[500px] grid grid-rows-[auto_1fr]"
    round
  >
    <ThreadsNav show-back>
      <template #left>
        <button
          class="btn btn-ghost btn-sm"
          @click="translateStore.showLangSelection = false"
        >
          {{ $t("Message.cancel") }}
        </button>
      </template>
      <template #center>
        <div class="font-bold text-base">
          {{ $t("translate.selectTranslateLanguage") }}
        </div>
      </template>
      <template #right>
        <button
          class="btn btn-primary btn-sm"
          @click="
            translateStore.targetLang = tmpVal;
            translateStore.showLangSelection = false;
          "
        >
          {{ $t("Buttons.confirm") }}
        </button>
      </template>
    </ThreadsNav>
    <div class="p-4 flex flex-col overflow-y-auto gap-2">
      <div
        v-for="item in langList"
        :key="item.value"
        :class="{
          'border-secondary/20': item.value !== tmpVal,
          'border-primary': item.value === tmpVal,
        }"
        class="flex border p-2 rounded cursor-pointer justify-between"
        @click="tmpVal = item.value"
      >
        <div>{{ $t(item.label) }}</div>
        <Radio :checked="item.value === tmpVal" />
      </div>
    </div>
  </Popup>
</template>
